<template lang="html">

  <section class="implicit_packs">
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <b-collapse id="implicit_packs_filters" class="mt-2 ml-4 mr-4">
            <b-card>
              <p class="card-text">Filters</p>
              <div class="row">
                <div class="col-lg-3 mt-2">Code:</div><input type="text" class="col-lg-3" v-model="code" placeholder="Code"/>
                <div class="col-lg-3 mt-2">Pack name:</div><input type="text" class="col-lg-3" v-model="description" placeholder="Pack name"/>
              </div>
              <br>
              <div class="row">
                <div class="col-lg-3 mt-2">Preview Data:</div><input type="checkbox" v-model="previewData"/>
              </div>
              <b-button variant="primary" v-b-toggle.implicit_packs_filters @click="search()"><i class="mdi mdi-magnify"></i>Search</b-button>
            </b-card>
          </b-collapse>
          <div class="col-lg-12 card-body row">
            <div class="col-lg-2">
              <h4 class="card-title">Implicit Packs</h4>
            </div>
            <div class="col-lg-4">             
              <div class="col-lg-12 row">
                <b-pagination
                   align="fill"
                  limit="6"
                  v-model="currentPage"
                  :total-rows="totalRowsResult"
                  :per-page="perPage"
                  first-text="<<"
                  prev-text="<"
                  next-text=">"
                  last-text=">>"
                  ellipsisText="..."
                  aria-controls=""
                  class="col-lg-10"
                ></b-pagination>               
              </div>
            </div>
            <div class="col-lg-1">
                <b-form-select id="perPage-dd" v-model="perPage" class="col-lg-12">
                 <b-form-select-option value="5">5</b-form-select-option>
                  <b-form-select-option value="10">10</b-form-select-option>
                  <b-form-select-option value="20">20</b-form-select-option>
                  <b-form-select-option value="50">50</b-form-select-option>
                  <b-form-select-option value="100">100</b-form-select-option>
                </b-form-select>
            </div>
            <div class="col-lg-5">
              <span class="float-right">
                <b-button variant="primary mr-1" v-b-modal.modal-export><i class="mdi mdi-file-export"></i>Export packs</b-button>
                <b-button variant="primary mr-1" v-b-modal.modal-import><i class="mdi mdi-file-import"></i>Import packs</b-button>
                <b-button variant="primary mr-1" v-b-toggle.implicit_packs_filters><i class="mdi mdi-filter"></i></b-button>
                <b-button variant="primary mr-1" @click="search"><i class="mdi mdi-refresh"></i>Refresh Table</b-button>
              </span>
            </div>
            <b-table ref="implicit_packs_tab"
              id="table" 
              striped 
              hover 
              responsive 
              :items="items" 
              :fields="fields"
              :per-page="perPage"
              :current-page="1"
              primary-key="id"
              no-local-sorting
              no-provider-paging
              sort-icon-left
            >
              <template v-slot:cell(ocparObj)="data" lang="html">
                {{data.item.ocparObj.parele + " - " + (data.item.ocparObj.parde2 != null ? data.item.ocparObj.parde2 : "")}}
              </template>
              <template v-slot:cell(masPackOpts)="data" lang="html">
                <ul>
                  <li v-for="opt in data.item.masPackOpts" :key="opt.id">{{opt.ocparObj.parele + " - " + (opt.ocparObj.parde2 != null ? opt.ocparObj.parde2 : "")}}</li>
                </ul>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
    <importExportPack :model="null" :previewData="previewData" @refresh="search"/>
  </section>
</template>
<script lang="js">
import { mapActions, mapGetters } from "vuex";
import importExportPack from '../../components/import_export_pack.vue';
export default {
  name: 'implicit_packs',
  components: {importExportPack},
  methods: {
    search() {
      this.setLastSearch(this.search) 
      this.setSpinnerStatus(true);
      var params = {page: this.currentPage - 1, size: this.perPage, sortBy: this.sortBy, sortDesc: this.sortDesc, code: this.code, description: this.description, previewData: this.previewData};
      this.axios.get('/ccb/auth/fe/packConf/findImplicitAll', {params: params, ...this.authHeader})
        .then((response) => {
          this.setSpinnerStatus(false);
          this.items = response.data.content;
          this.totalRowsResult = response.data.totalElements;           
        });
    },
    ...mapActions([
      'setCurApp',
      'setSpinnerStatus',
      'setLastSearch'
    ])
  },
  data () {
    return {
      totalRowsResult: 0,
      currentPage: 1,
      perPage: 10,
      sortBy: 'id',
      sortDesc: false,
      fields: [
        {
          key: 'ocparObj',
          label: 'Pack name'
        },
        {
          key: 'masPackOpts',
          label: 'Implicit'
        }
      ],
      items: [],
      code: '',
      description: '',
      previewData: false
    }
  },
  computed: {
    ...mapGetters([
      'authHeader'
    ])
  },
   watch: {
    currentPage(newValue,oldValue){
      this.search();
    },
    perPage(newValue,oldValue){
      this.search();
    },
    sortBy(newValue,oldValue){
      this.search();
    },
    sortDesc(newValue,oldValue){
      this.search();
    }
  },
  mounted() { 
    this.setCurApp('pack_conf');
    this.search();
  },
}
</script>

<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
.collapse {
  border: 1px solid $gray-lightest;
  border-radius: 0.25rem;
}
</style>
